/** @jsxImportSource @emotion/react */
'use client'

import { css } from '@emotion/react'
import { colorTokens, spacingTokens } from '../../styles/tokens'
import { ClaimRoutingCard } from '../cards'
import Button from './Button'
import Container from './Container'

const styles = {
  section: css`
		position: relative;
    text-wrap: balance;
		overflow: clip;
    padding: ${spacingTokens.sectionGap * 2}px ${spacingTokens.pageMargin}px;
  `,
  container: css`
		display: flex;
		position: relative;
		flex-direction: column;
		gap: ${spacingTokens.cardGap * 2}px;

		@media (min-width: 768px) {
			display: grid;
			grid-template-columns: 1.5fr 1fr;
			align-items: center;
		}
  `,
  content: css`
    display: flex;
    flex-direction: column;
		justify-content: center;
		text-align: center;
    gap: ${spacingTokens.cardGap * 2}px;
		
		@media (min-width: 768px) {
			text-align: left;
			align-items: flex-start;
			justify-content: flex-start;
		}
  `,
  eyebrow: css`
    font-size: 14px;
    font-weight: 700;
    text-transform: uppercase;
    color: ${colorTokens.green100};
  `,
  heading: css`
    font-family: var(--font-cabinet-grotesk), 'system-ui', Arial, sans-serif;
    font-weight: 900;
    font-size: clamp(2.5rem, 6vw, 4.5rem);
    line-height: 1.05;
    letter-spacing: -0.02em;
    max-width: 900px;
    margin: 0;
    text-box: trim-both cap alphabetic;
    color: ${colorTokens.green900};
  `,
  description: css`
    font-size: clamp(1rem, 2vw, 1.25rem);
    line-height: 1.6;
    max-width: 720px;
    margin: 0;
    color: ${colorTokens.slate500};
  `,
  ctas: css`
    display: flex;
    flex-wrap: wrap;
    gap: ${spacingTokens.elementGap}px;
		justify-content: center;
		
		@media (min-width: 768px) {
			gap: ${spacingTokens.cardGap}px;
			justify-content: flex-start;
		}
  `,
}

interface HeroProps {
  onCtaClick: () => void
}

export default function Hero({ onCtaClick }: HeroProps) {
  return (
    <section css={styles.section}>
      <Container css={styles.container}>
        <div css={styles.content}>
          <span css={styles.eyebrow}>AI-powered claims</span>
          <h1 css={styles.heading}>
            The AI Driven Solution For Your Outsourced Needs
          </h1>
          <p css={styles.description}>
            WyseHub uses AI to pair each claim with the right outsourced
            partner, harnessing data to improve accuracy, speed, and conversion.
            One platform for seamless integration, on-demand reporting, and
            effortless scalability.
          </p>
          <div css={styles.ctas}>
            <Button size="large" variant="primary" onClick={onCtaClick}>
              Go to HomeHub
            </Button>
            <Button
              href="mailto:contact@wysehub.co.uk"
              size="large"
              variant="secondary"
            >
              Get in touch
            </Button>
          </div>
        </div>
        <ClaimRoutingCard />
      </Container>
    </section>
  )
}
